export default __webpack_public_path__ + "static/media/no-data.dbdf15ea.png";